import Vue from 'vue';
import VueRouter from 'vue-router';
import PageRouter from './page/'
import ViewsRouter from './views/'
import BasicRouter from './basic/'
import SalesCloudRouter from './salesCloud/'
import WorkRouter from './work/'
Vue.use(VueRouter);
export default new VueRouter({
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            // keep-alive页面的滚动位置由主布局组件的el-scrollbar管理
            // 这里只处理非缓存页面的window级别滚动
            if (to.meta.keepAlive) {
                return false
            }
            return {
                x: 0,
                y: 0
            }
        }
    },
});
export const asyncRouterMap = [].concat(PageRouter, ViewsRouter, BasicRouter, SalesCloudRouter, WorkRouter)